import { SITE_API_URI } from '@service/constants';
import SiteApiClient from '@service/siteApiClient';
import { saveAs } from '@service/fileSaver';
import moment from 'moment';

const client = new SiteApiClient(SITE_API_URI);

export function requestLicenseFile(siteName: string, siteId: number, accessToken: string) {
    return new Promise(
        (resolve, reject) => {

            client.getLicenseFile(siteId, accessToken).then((response: any) => {
                const serverFileName = getFileNameFromResponse(response);
                response.blob().then((data: any) => {
                    saveAs(data, serverFileName || getFileName(siteName));
                    resolve(data);
                }).catch((err: any) => {
                    reject(err);
                });
            }).catch((err: any) => {
                reject(err);
            });
        }
    );
}

function getFileNameFromResponse(response: any): string {
    const disposition = response?.headers?.get
        ? response.headers.get('content-disposition')
        : null;
    if (!disposition) {
        return '';
    }
    // Prefer RFC 5987 filename* (handles encoded names), fall back to plain filename.
    const utfMatch = /filename\*=(?:UTF-8'')?([^;]+)/i.exec(disposition);
    if (utfMatch?.[1]) {
        return decodeURIComponent(utfMatch[1].replace(/(?:^")|(?:"$)/g, '').trim());
    }
    const asciiMatch = /filename="?([^";]+)"?/i.exec(disposition);
    if (asciiMatch?.[1]) {
        return asciiMatch[1].trim();
    }
    return '';
}

function getFileName(siteName: string) {
    return siteName + '_Licenses_' + moment().format('YYYY_MM_DD_HH_mm') + '.zip';
}
